<script>
import FormInput from '../forms/FormInput.vue';
import FormPasswordInput from '../forms/FormPasswordInput.vue';
import FormPhoneInput from '../forms/FormPhoneInput.vue';
import FormSwitchCheckbox from '../forms/FormSwitchCheckbox.vue';
import DateInput from '../forms/DateInput.vue';
import FormModal from '../modals/FormModal.vue';
export default {
    components: {
        FormInput,
        FormPasswordInput,
        FormPhoneInput,
        FormSwitchCheckbox,
        DateInput,
        FormModal
    },
    props: {
        showModal: Boolean,
        modalTitle: String,
        createClientRoute: {
            type: String,
            default: function () {
                return null;
            },
        },
        clientListType: {
            type: String,
            default: function () {
                return null;
            },
        },
    },

    data() {
        let modalTitle = `Create ${this.modalTitle}`
        return {
            isButtonLoading: false,
            clientCreateForm: {
                myname: null,
                email: null,
                auto_generate: true,
                password: null,
                password_confirmation: null,
                phone: null,
                company_name: null,
                website: null,
                platform: 'Vue'
            },
            clientCreateExtraFields: {              
                dob: null,
                personal_email: null,
                mail_address: null,
                efin: null,
                ptin: null,
                yib: null,
                noc: null,
                bank_history: null,
                ssn: null,
                fax: null,
                noe: null,
                nobp: null
            },
            submitButtonText: 'Submit',
            createModalTitle: modalTitle
        }
    },

    methods: {
        handleClientCreateSubmit() {
            this.isButtonLoading = true;
            this.submitButtonText = `<i class="bx bx-loader bx-spin font-size-16 align-middle me-2"
                        ></i>
                        Loading`;
            if(this.clientListType == 'TC' && this.userType == 2) {
                this.clientCreateForm = {...this.clientCreateForm, ...this.clientCreateExtraFields}
            }
            this.$inertia.post(this.createClientRoute, this.clientCreateForm, {
                onSuccess: (response) => {
                    this.$emit('onClose');
                    this.$toastr.s("Created Successfully");
                    this.submitButtonText = 'Submit';
                    this.isButtonLoading = false;
                    this.clientCreateForm = {
                        myname: null,
                        email: null,
                        auto_generate: true,
                        password: null,
                        password_confirmation: null,
                        phone: null,
                        company_name: null,
                        website: null,
                        platform: 'Vue'
                    };
                    if(this.clientListType == 'TC' && this.userType == 2) {
                        this.clientCreateExtraFields = {
                            dob: null,
                            personal_email: null,
                            mail_address: null,
                            efin: null,
                            ptin: null,
                            yib: null,
                            noc: null,
                            bank_history: null,
                            ssn: null,
                            fax: null,
                            noe: null,
                            nobp: null
                        }
                    }
                },
                onError: (errors) => {
                    this.isButtonLoading = false;
                    this.submitButtonText = 'Submit';
                    if (errors.message) {
                        this.$toastr.e(errors.message);
                    }
                },
            });
        },

        hideModal(){
            this.$emit('onClose')
        },
    },

    computed: {
        // Example 1,2,3,4
        userType() {
            return this.$page.props.auth.user.user_type;
        },
        phoneIsMandatory() {
            if(this.clientListType == 'TP') {
                return false
            }
            return true
        }
    }
};
</script>

<template>
    <FormModal
        :isShow="showModal"
        :title="createModalTitle"
        :isButtonLoading="isButtonLoading"
        :isShowSubmitButton="true"
        :isShowCancelButton="true"
        :clickSubmitButton="handleClientCreateSubmit"
        :submitButtonText="submitButtonText"
        @hideModal="hideModal"
    >
        <div class="row">
            <div class="col-12">
                <div class="mb-3">
                    <FormInput title="Full Name" v-model='clientCreateForm.myname' :required="true" :error="$page.props.errors.myname" type="text" name="myname" />
                </div>
            </div>
            <div class="col-12">
                <div class="mb-3">
                    <FormInput title="Email" v-model='clientCreateForm.email' :required="true" :error="$page.props.errors.email" type="text" name="email" />
                </div>
            </div>
            <div class="col-12">
                <FormSwitchCheckbox id="generate_password" v-model="clientCreateForm.auto_generate" name="auto_generate" label="Auto Generate Password" classes="mb-3"/>
            </div>

            <template v-if="!clientCreateForm.auto_generate">
                <div class="col-12">
                    <div class="mb-3">
                        <FormPasswordInput refID="password" title="Password" v-model='clientCreateForm.password' :required="true" :error="$page.props.errors.password" type="password" name="password" />
                    </div>
                </div>

                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Confirm Password" v-model='clientCreateForm.password_confirmation' :required="true" :error="$page.props.errors.password_confirmation" type="password" name="password_confirmation" />
                    </div>
                </div>
            </template>

            <div class="col-sm-12">
                <div class="mb-3">
                    <FormPhoneInput title="Phone" :model='clientCreateForm.phone' :required="phoneIsMandatory" :error="$page.props.errors.phone" type="text" name="phone" @phoneFormatted="clientCreateForm.phone = $event" />
                </div>
            </div>
            <template v-if="clientListType == 'TC' && userType == 2">
                <div class="col-sm-12">
                    <div class="mb-3">
                        <DateInput title="Date of Birth" v-model='clientCreateExtraFields.dob' :required="false" :error="$page.props.errors.dob" :disabledDate="(date) => date >= new Date()" />
                    </div>
                </div>

                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Personal E-Mail" v-model='clientCreateExtraFields.personal_email' :required="false" :error="$page.props.errors.personal_email" type="text" name="personal_email" />
                    </div>
                </div>

                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Mailing Address" v-model='clientCreateExtraFields.mail_address' :required="false" :error="$page.props.errors.mail_address" type="text" name="mail_address" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="E-Fin" v-model='clientCreateExtraFields.efin' :required="false" :error="$page.props.errors.efin" type="text" name="mail_address" maximumlength="6" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="P-Tin" v-model='clientCreateExtraFields.ptin' :required="false" :error="$page.props.errors.ptin" type="text" name="ptin" maximumlength="8" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="Years in Business" v-model='clientCreateExtraFields.yib' :required="false" :error="$page.props.errors.yib" type="number" name="yib" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="Number of Clients" v-model='clientCreateExtraFields.noc' :required="false" :error="$page.props.errors.noc" type="number" name="noc" />
                    </div>
                </div>

                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Banking History" v-model='clientCreateExtraFields.bank_history' :required="false" :error="$page.props.errors.bank_history" type="text" name="bank_history" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="Social Security Number" v-model='clientCreateExtraFields.ssn' :required="false" :error="$page.props.errors.ssn" type="number" name="ssn" maximumlength="9" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="Fax Number" v-model='clientCreateExtraFields.fax' :required="false" :error="$page.props.errors.fax" type="text" name="fax" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="Number of Employees" v-model='clientCreateExtraFields.noe' :required="false" :error="$page.props.errors.noe" type="text" name="noe" />
                    </div>
                </div>

                <div class="col-sm-6">
                    <div class="mb-3">
                        <FormInput title="Number of Bank Products" v-model='clientCreateExtraFields.nobp' :required="false" :error="$page.props.errors.nobp" type="number" name="nobp" />
                    </div>
                </div>
            </template>
            <template v-if="this.userType !== 3">
                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Website URL" v-model='clientCreateForm.website' :required="false" :error="$page.props.errors.website" type="text" name="website" />
                    </div>
                </div>

                <div class="col-12">
                    <div class="mb-3">
                        <FormInput title="Company Name" v-model='clientCreateForm.company_name' :required="false" :error="$page.props.errors.company_name" type="text"  name="company_name" />
                    </div>
                </div>
            </template>
        </div>
    </FormModal>
</template>